module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-423a89f3.png";